import styles from './HeroSection.module.css'
import {Card} from "@/widgets/catalog/HeroSection/Card.jsx";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";
import MobileInfiniteRow from "@/shared/ui/MobileInfiniteRow/MobileInfiniteRow.jsx";

const cardsTitles = ['CYBERPUNK RED','D&D 5e', 'Witcher', 'cy borg', 'STARFINDER', 'fallout'];

const HeroSection = () => {
    const isMobile = useIsMobile();

    return (
        <>
            {/* mobile: первая строка — влево */}
            {isMobile && (
                <div style={{
                    paddingTop: "10px",
                }}>
                    <MobileInfiniteRow direction="left" speed={0.5}>
                    {cardsTitles.map((title, index) => (
                        <Card key={index} name={title} index={index} />
                    ))}
                </MobileInfiniteRow>
                </div>
            )}
            <section className={`${styles.sect} container-custom`}>

                {/* Desktop title */}
                <h1 className={styles.title}>Каталог игр</h1>

                {/* Desktop rows */}
                {!isMobile && (
                    <>
                        <div className={styles.row}>
                            {cardsTitles.map((title, index) => (
                                <Card key={index} name={title} index={index} />
                            ))}
                        </div>

                    </>
                )}
            </section>

            {/* mobile: вторая строка — вправо */}
            {isMobile && (
                <MobileInfiniteRow direction="right" speed={0.5}>
                    {cardsTitles.map((title, index) => (
                        <Card key={index} name={title} index={index} />
                    ))}
                </MobileInfiniteRow>
            )}
        </>
    );
};

export default HeroSection;
